import CloseIcon from "@mui/icons-material/Close";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    Slide,
    TextField,
    Typography,
    Modal
} from "@mui/material";
import React, { useEffect, useState } from "react";
import QRReader from "../QR/QrReader";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function QRReaderDialog({ open, onClose, onQRCodeScanSuccess, onManualSuccess, isLoading }) {
    // Dialog states
    const [isManualEntryPromptOpen, setManualEntryPromptOpen] = useState(false);
    const [manualEntry, setManualEntry] = useState("");

    // Open manual entry
    const toggleManualEntryPrompt = () => {
        setManualEntryPromptOpen(!isManualEntryPromptOpen);
    };

    // Set manual entry
    const handleManualEntryChange = (event) => {
        setManualEntry(event.target.value);
    };

    // Submit manual entry
    const handleManualEntrySubmit = () => {
        if (!manualEntry || isLoading) {
            return;
        }
        if (manualEntry && !isLoading) {
            onManualSuccess(manualEntry);
        }
    };

    // QR success
    const handleQRCodeScanSuccess = (qrdata) => {
        if (!qrdata || isLoading) return;
        if (qrdata && !isLoading) {
            onQRCodeScanSuccess(qrdata);
        }
    };

    // Clear states
    const handleOnClose = () => {
        setManualEntryPromptOpen(false);
        setManualEntry("");
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleOnClose}
        >
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", bgcolor: "background.paper", p: 2, position: 'relative' }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                    <Typography variant="h6">Scan QR code</Typography>
                    <IconButton aria-label="close" onClick={handleOnClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {isManualEntryPromptOpen && (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", mt: 2 }}>
                        <TextField
                            label="Equipment Number"
                            placeholder="Enter code manually"
                            value={manualEntry}
                            onChange={handleManualEntryChange}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                        />
                        <Button
                            onClick={handleManualEntrySubmit}
                            disabled={isLoading}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ mt: 2 }}
                        >
                            {isLoading ? <CircularProgress color="inherit" size={24} /> : "Submit"}
                        </Button>
                    </Box>
                )}

                <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: '80%' }}>
                    {!isManualEntryPromptOpen && <QRReader onScanSuccess={handleQRCodeScanSuccess} />}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                        <IconButton onClick={toggleManualEntryPrompt} sx={{
                            backgroundColor: "#f3f3f3",
                        }}>
                            {isManualEntryPromptOpen ? <QrCodeScannerIcon fontSize="large" /> : <TextFieldsIcon fontSize="large" />}
                        </IconButton>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}

export default QRReaderDialog;
